
import Vue from 'vue';


import { readUserChip, readConfigFile } from './file';


export async function loadData(state) {
    
    let chip = await readUserChip(state);

            
    if (!chip) {
        // alert(state.model)
        chip = await readConfigFile(state, state.model);
    }

    state.chip = chip;

    await loadIpData(state, 'GPIO');
}

export async function loadIpData(state, ipName) {
    if (state.config.hasOwnProperty(ipName)) {
        return;
    }

    const ipInstance = state.chip.ips.find(ip => ip.name === ipName)
    if (ipInstance) {
        const ipConfig = await readConfigFile(state, ipInstance.config);

        Vue.set(state.config, ipName, ipConfig);

        // const ips = state.chip.ips.filter(ip => ip.name === ipName);
        // for(const ip in ips) {
        //     if (ip.name === 'USART') {

        //     }
        // }
    }
}


